
const nuevosCursos = ['XLAM'];


export const validateServerCurso = (codigoLeccion) => {
    return new Promise((resolve, reject) => {
        if(nuevosCursos.includes(codigoLeccion.substring(0,4))){
            // console.log('Es del nuevo server')
            resolve(false);
        } else {
            // console.log("Es del server actual")
            resolve(true);
        }
    })
}